import React from "react";
import TopicBlurhashImage from "./TopicBlurhashImage";

const BlogContent = ({ topics }) => {
  return (
    <div className="blog-explanation">
      {topics?.map((item, index) => (
        <div key={index} className="blog-topic">
          {item.image && (
            <TopicBlurhashImage
              src={item.image}
              alt={item.image_caption}
              className="topic-images"
              hash="LEHV6nWB2yk8pyo0adR*.7kCMdnj"
            />
          )}

          {item.image_caption && (
            <div className="blogger-image-caption">
              <h6 className="blogger-name">{item.image_caption}</h6>
            </div>
          )}

          {item.heading && <h4 className="topic-heading">{item.heading}</h4>}
          {item.sub_heading && (
            <h5 className="topic-subheading">{item.sub_heading}</h5>
          )}

          {item.paragraphs &&
            item.paragraphs.map((paragraph, idx) => (
              <p key={idx} className="blog-description">
                {paragraph}
              </p>
            ))}

          {item.iframe && (
            <iframe
              src={item.iframe}
              title={item.sub_heading}
              className={`topic-iframe ${
                item.iframe.includes("youtube")
                  ? "iframe-youtube"
                  : "iframe-other"
              }`}
            />
          )}
        </div>
      ))}
    </div>
  );
};

export default BlogContent;
